module.exports = __webpack_public_path__ + "img/_dsc8168.05488e57.jpg";